module.exports = __webpack_public_path__ + "img/instagram.ca92f2ed.svg";